module.exports = __webpack_public_path__ + "static/img/BIMOM.83ab6876.jpg";